import { useQuery } from '@tanstack/react-query';
import { SaleData } from '@interfaces/api/responses/my-sale';
import useUser from '@hooks/user/use-user';
import { getSales } from '@services/my-orders-sales-service';
import { OrdersSalesQueryKeys } from '@enums/react-query-keys';

const useSaleProductShipping = () => {
  const { user, isAuthenticated } = useUser();
  const userId = user?.id ?? '';

  const { isFetching, data, isError } = useQuery<SaleData>({
    queryKey: [OrdersSalesQueryKeys.PRODUCT_SHIPPING, userId],
    queryFn: ({ pageParam = 1 }) => {
      return getSales(Number(pageParam));
    },
    staleTime: Infinity,
    enabled: isAuthenticated,
  });

  return { isFetching, data, isError };
};

export default useSaleProductShipping;
